import { LifecycleSurveysModel } from 'api/dto/LifecycleSurveys.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'onboardSurveys';

export namespace OnboardSurveysState {
  export type Domain = {
    resource: Resource<LifecycleSurveysModel | null>;
  };

  export const INITIAL_DOMAIN: Domain = {
    resource: Resource.createPendingResource(),
  };
}
